"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const moment_1 = __importDefault(require("moment"));
const ConfirmModal_1 = __importDefault(require("../modal/ConfirmModal"));
const Auth_1 = require("../../actions/Auth");
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const application_config_1 = __importDefault(require("../../config/application.config"));
const UserMenuButton = ({ menuItem, modalOpenedCallback, closeMenu }) => {
    const [modalIsOpened, setModalIsOpened] = react_1.default.useState(false);
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    const toggleModal = (opened) => {
        setModalIsOpened(opened);
        modalOpenedCallback(opened);
    };
    const executeAction = (e) => {
        menuItem.action(e);
        if (menuItem.postExec === 'refreshLang') {
            i18n.changeLanguage(i18n.language);
        }
        closeMenu();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { type: "button", className: "menu-button", onClick: menuItem.confirmModal === undefined ? executeAction : () => toggleModal(true) }, menuItem.getText(t)),
        modalIsOpened && menuItem.confirmModal && (react_1.default.createElement(ConfirmModal_1.default, { isOpen: true, title: menuItem.confirmModal.title(t), confirmAction: executeAction, confirmButtonColor: "red", confirmButtonLabel: menuItem.confirmModal.label(t), closeModal: () => toggleModal(false) }))));
};
const UserMenu = ({ wrapperRef, closeMenu }) => {
    const [hasModalOpened, setHasModalOpened] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target) && !hasModalOpened) {
                closeMenu();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [wrapperRef, hasModalOpened, closeMenu]);
    return (react_1.default.createElement("div", { className: "menu userMenu", ref: wrapperRef }, application_config_1.default.userMenuItems.map((menuItem, index) => (react_1.default.createElement(UserMenuButton, { key: `header__nav-user${index}`, menuItem: menuItem, modalOpenedCallback: setHasModalOpened, closeMenu: closeMenu })))));
};
const User = ({ user }) => {
    const [display, setDisplay] = react_1.default.useState(false);
    const wrapperRef = react_1.default.useRef(null);
    const { t } = (0, react_i18next_1.useTranslation)('menu');
    return (react_1.default.createElement("li", { className: "tr__top-menu-element", id: "item-nav-user" },
        react_1.default.createElement("button", { className: "menu-button", type: "button", onClick: application_config_1.default.userMenuItems.length > 0 ? () => setDisplay(!display) : undefined }, user.username || user.email || t('menu:User')),
        display && (react_1.default.createElement(UserMenu, { wrapperRef: wrapperRef, user: user, closeMenu: () => setDisplay(false) }))));
};
const Header = ({ path }) => {
    const navigate = (0, react_router_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t, i18n } = (0, react_i18next_1.useTranslation)('menu');
    const user = (0, react_redux_1.useSelector)((state) => state.auth.user);
    const handleLogout = () => {
        dispatch((0, Auth_1.startLogout)(navigate));
    };
    const appTitle = project_config_1.default.appTitle;
    const title = project_config_1.default.title[i18n.language];
    return (react_1.default.createElement("header", { className: "header" },
        react_1.default.createElement("div", { className: "header__content" },
            react_1.default.createElement("nav", { className: "header__nav-left", id: "item-nav-title" }, appTitle !== undefined ? (react_1.default.createElement("h1", null,
                appTitle,
                " \u2022 ",
                react_1.default.createElement("strong", null, title))) : (react_1.default.createElement("h1", null, title))),
            react_1.default.createElement("nav", { className: "header__nav-right" },
                react_1.default.createElement("ul", null,
                    user &&
                        user.pages.map((page) => (react_1.default.createElement("li", { className: "tr__top-menu-element", key: `item-${page.title}` },
                            react_1.default.createElement(react_router_1.NavLink, { className: "menu-button", to: page.path }, t(page.title))))),
                    !user && path !== '/login' && project_config_1.default.showLogin !== false && (react_1.default.createElement("li", { className: "tr__top-menu-element" },
                        react_1.default.createElement(react_router_1.NavLink, { className: "menu-button", to: "/login" }, t('menu:login')))),
                    user && project_config_1.default.showLogout !== false && (react_1.default.createElement("li", { className: "tr__top-menu-element" },
                        react_1.default.createElement("button", { type: "button", className: "menu-button", onClick: handleLogout }, t('menu:logout')))),
                    project_config_1.default.languages.map((language) => i18n.language !== language ? (react_1.default.createElement("li", { className: "tr__top-menu-element", key: `lang-${language}` },
                        react_1.default.createElement("button", { type: "button", className: "menu-button em", lang: language, onClick: () => {
                                i18n.changeLanguage(language);
                                moment_1.default.locale(i18n.language);
                            } }, project_config_1.default.languageNames[language]))) : null),
                    user && react_1.default.createElement(User, { user: user }))))));
};
exports.default = Header;
//# sourceMappingURL=Header.js.map